<template>
  <BreadCrumb PageTitle="Modifier Client" />
  <EditCustomer :userId="userId"  />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import EditCustomer from "../../components/Customers/EditCustomer.vue";
import { useRoute } from "vue-router";
export default defineComponent({
  name: "EditCustomerPage",
  components: {
    BreadCrumb,
    EditCustomer,
  },

  setup: () => {
    const route = useRoute();
    let userId = route.params.id;  // <-- get the id
    if (Array.isArray(userId)) {
      userId = userId[0] ?? "";
    }


    return { userId };
}
});
</script>